/*
 * @FileName       : report.reducer.ts
 * @Version        : 1.0
 * @DateOfCreation : 04/21/2020
 * @Author         : $u^^!t @ FFF Enterprises
 * @Dependencies   : N/A
 * @Description    : report reducer to handle report events.
 *
 * Copyright (c) 2020, FFF Enterprises. All rights reserved.
 */

import createReducer from './createReducer';
import { ReportActions } from '../actions';
import { REPORTS } from '../constants/actions';

export const reports = createReducer(
	{},
	{
		[REPORTS.INVENTORY.HISTORY.LIST_RESPONSE](
			state = {},
			action: ReturnType<typeof ReportActions.successInventoryHistory>,
		) {
			return {
				...state,
				inventoryHistory: action.payload ? action.payload.result : null,
				inventoryHistoryCount: action.payload ? action.payload.total_record : null,
			};
		},

		[REPORTS.CLEAR_GLOBAL_DATA](state = {}, action: ReturnType<typeof ReportActions.clearGlobalData>) {
			return {
				...state,
				inventoryHistory: null,
				inventoryHistoryCount: null,
				recentlyVended: null,
				transactionGroups: null,
				transactionGroupNames: null,
			};
		},

		[REPORTS.INVENTORY.CURRENT.LIST_RESPONSE](
			state = {},
			action: ReturnType<typeof ReportActions.successCurrentInventory>,
		) {
			return {
				...state,
				...{
					[action.payload.product_item_id + '-' + action.payload.cabinet_type + '-' + action.payload.cabinet_id]:
						action.payload.data,
				},
			};
		},

		[REPORTS.INVENTORY.USAGE.LIST_RESPONSE](
			state = {},
			action: ReturnType<typeof ReportActions.successRecentlyVended>,
		) {
			return { ...state, recentlyVended: action.payload };
		},

		[REPORTS.INVENTORY.GROUP.CLEAR_LIST](state = {}, action: ReturnType<typeof ReportActions.clearInventoryGroup>) {
			return { ...state, inventoryGroups: [] };
		},

		[REPORTS.INVENTORY.USAGE.CLEAR_USAGE_LIST](
			state = {},
			action: ReturnType<typeof ReportActions.clearRecentlyVended>,
		) {
			return { ...state, recentlyVended: { result: [], total_record: 0 } };
		},
		[REPORTS.INVENTORY.CURRENT.FIX_COLUMNS_SUCCESS](
			state = {},
			action: ReturnType<typeof ReportActions.fixTableColumnSuccess>,
		) {
			return { ...state, fixedTableColumns: { report_child_table: action.payload } };
		},

		[REPORTS.INVENTORY.GROUP.REPORT_FILTER_SUCCESS](
			state = {},
			action: ReturnType<typeof ReportActions.setFilterSuccess>,
		) {
			return { ...state, reportFilters: action.payload };
		},

		[REPORTS.INVENTORY.USAGE.SET_GROUP](state = {}, action: ReturnType<typeof ReportActions.setTransactionGroupLog>) {
			return { ...state, transactionGroups: action.payload };
		},

		[REPORTS.INVENTORY.USAGE.SET_GROUP_NAMES](
			state = {},
			action: ReturnType<typeof ReportActions.setTransactionGroupNames>,
		) {
			return { ...state, transactionGroupNames: action.payload };
		},

		[REPORTS.DISPENSED.SET](state = {}, action: ReturnType<typeof ReportActions.successRecentlyVended>) {
			return { ...state, dispensedProducts: action.payload };
		},

		[REPORTS.CYCLE_COUNTS.SET](state = {}, action: ReturnType<typeof ReportActions.setCycleCounts>) {
			return { ...state, cycleCounts: action.payload };
		},

		[REPORTS.SHIPMENTS.SET](state = {}, action: ReturnType<typeof ReportActions.successRecentlyVended>) {
			return { ...state, warehouseShipments: action.payload };
		},

		[REPORTS.SET_RESTOCK_ORDER_DETAILS.IG_SHIPMENT_ITEMS](
			state = {},
			action: ReturnType<typeof ReportActions.setRestockOrderDetails_igShipmentItems>,
		) {
			return { ...state, restockOrderDetails_igShipmentItems: action.payload };
		},

		[REPORTS.SET_RESTOCK_ORDER_DETAILS.WAREHOUSE_SHIPMENT](
			state = {},
			action: ReturnType<typeof ReportActions.setRestockOrderDetails_warehouseShipment>,
		) {
			return { ...state, restockOrderDetails_warehouseShipment: action.payload };
		},

		[REPORTS.SET_RESTOCK_ORDER_DETAILS.RESTOCK_REQUEST](
			state = {},
			action: ReturnType<typeof ReportActions.setRestockOrderDetails_restockRequest>,
		) {
			return { ...state, restockOrderDetails_restockRequest: action.payload };
		},

		[REPORTS.SET_RESTOCK_ORDER_DETAILS.TRANSACTIONS](
			state = {},
			action: ReturnType<typeof ReportActions.setRestockOrderDetails_transactions>,
		) {
			return { ...state, restockOrderDetails_transactions: action.payload };
		},

		[REPORTS.SET_RESTOCK_ORDER_DETAILS.SAP_ORDERS](
			state = {},
			action: ReturnType<typeof ReportActions.setRestockOrderDetails_sapOrders>,
		) {
			return { ...state, restockOrderDetails_sapOrders: action.payload };
		},
	},
);
